import React from 'react';

export const LeadSuccessModal = (props) => {

    const { handleSuccessModalVisible } = props;

    return (
        <>
            <div className='backdrop' onClick={handleSuccessModalVisible }>

            </div>
            <div className="modal show leadGenerationModel" role="dialog" style={{ display: 'block' }}>
                <div className="modal-dialog">
                    <div className="modal-content-center">
                        <button type="button" className="close" onClick={handleSuccessModalVisible}>
                            <img src="/Images/X.png" width="24" height="24" alt='' />
                        </button>
                        <div className="mx-auto w-80 h-80 mb-3">
                            <img src="/Images/success_icon.png" alt='Success icon' />
                        </div>
                        <div className="congrats-container congratsModalNN mb-2">
                            Your request successfully submitted.
                        </div>
                        <div className="congratsModalNNCaption">
                            Our business team will contact with you soon.
                        </div>
                        <div className="mx-auto callBackContainer">
                            <div className="mt-4">
                                <button className="summary-btn px-4" onClick={handleSuccessModalVisible}>Ok, Got it</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}